// extracted by mini-css-extract-plugin
export var cardHeader = "_tv-0";
export var reorderHandle = "_tv-3";
export var titleArea = "_tv-1";
export var titleAreaWithHandle = "_tv-2";